var exports = {
  "u": "xcc377c0b--67ba11--toggle-btn",
  "q": "xcc377c0b--67ba11--toggle-btn--close",
};

module.exports = exports;
